import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type YtVideoData = {
  url: string
  marginBottom?: string
}

export const ytvideo: DynamicContentType<YtVideoData> = {
  name: 'ytvideo',
  viewName: 'Video',
  featureKey: 'ytvideo',
  icon: LucideIconName.Film,
  default: true,
  uuid: '',
  data: {
    url: '',
  },
}
